import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  background-position: center 30%;
  
  &:after {
    content: '';
    position: absolute;
    background: #00000070;
    width: 100%;
    height: 100%;
    z-index: 1;
    backdrop-filter: blur(4px) saturate(180%);
  }
  
  > main {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;  
    z-index: 2;  
    
    > section {
      display: flex;
      flex-direction: row;
      width: 800px;
      height: fit-content;
      color: rgb(34, 51, 84);
      transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      border-radius: 16px;
      overflow: hidden;

      @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      
      > aside {
        position: relative;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        width: 50%;
        height: auto;
        display: flex;
        justify-content: flex-end;
        flex-direction:column;
        padding: 3rem;

        @media (max-width: 768px) {
          display: none;
        }
        
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, transparent 0%, rgba(0,0,0, 0.7) 100%);
          z-index: 0;
        }
        
        > h3 {
          margin-bottom: 1rem;
          z-index: 2;
          color: #fff;
        }

        > p {
          font-size: 16px;
          z-index: 2;
          color: #ffffff90;
        }
      }
      
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 2rem;
      }
      
      > main {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 50%;
        padding: 2rem;
        background: #dadbe724;
        backdrop-filter: blur(25px);

        @media (max-width: 768px) {
          border-radius: 16px;
          width: 80%;
        }

        @media (max-width: 600px) {
          width: 90%;
        }
        
        > header {
          display: flex;
          justify-content: center;

          > img {
            width: 170px;
            margin-bottom: 2rem;
          }
        }
        
        > div {
          
          > h2 {
            margin-bottom: 1rem;
            color: #fff;
          }
          
          > p {
            margin-bottom: 2rem;
            color: #ffffff80;
            font-size: 14px;
            text-align: justify;
          }
        }

        > form {
          display: flex;
          flex-direction: column;
          
          > div {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 1rem;
            padding: 1.3rem 1rem 0.8rem 1rem;
            background: #ffffff17;

            &:nth-child(1) {
              border-radius: 8px 8px 0 0;
              border-bottom: 2px solid #dcdde50d;
            }

            &:nth-child(2) {
              border-radius: 0 0 8px 8px;
            }
            
            > aside {
            
              > svg {
                color: #dadee180;
              }
            }
            
            > main {
              position: relative;
              width: 100%;
              
              > label {
                position: absolute;
                display: block;
                font-size: 12px;
                top: -12px;
                color: #dadee180;
              }
              
              > input {
                width: 100%;
                background: none;
                padding: 5px 0;
                border: none;
                color: #fff;
              }
            }
          }

          > p {
            color: #ffffff;
            margin-top: 1rem;
            font-size: 12px;
            text-align: center;
            margin-bottom: 2rem;
            
            > span {
              font-weight: 900;
              cursor: pointer;
            }
          }
          
          > footer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            
            > button {
              margin-bottom: 1rem;
              text-align: center;
              width: 100%;
              display: flex;
              justify-content: center;
            }
            
            > p {
              font-size: 8px;
              color: #ffffff80;
            }
          }
        }

      }
    }
  }
`;

export const ModalForgetContainer = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.textColors};

  > h1 {
    margin-bottom: 1rem;
    color: #3e3f5e;
  }

  > p {
    color: ${props => props.theme.colors.muted};
  }

  > main {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    > form {
      display: flex;
      flex-direction: column;

      > label {
        position: absolute;
        margin: 6px 0 0 12px;
        padding: 2px 3px;
        background: ${props => props.theme.cards.modal};
        color: ${props => props.theme.colors.muted};
        display: inline;
        width: fit-content;
        z-index: 9;
      }

      > input {
        position: relative;
        padding: 1rem 1.2rem;
        margin-top: 1rem;
        background: #ffffff;
        border: 1px solid ${props => props.theme.colors.muted};
        border-radius: ${props => props.theme.radius.secondary};
        color: #3e3f5e;
        width: 100%;
        transition: all .3s ease-in-out;
        margin-bottom: 1rem;

        &input:-webkit-autofill,
        input:-webkit-autofill:hover, 
        input:-webkit-autofill:focus, 
        input:-webkit-autofill:active {
          box-shadow: none;
        }

        &::-webkit-autofill {
          -webkit-text-fill-color: ${props => props.theme.colors.white};
        }
      }

      > button {
        display: flex;
        justify-content: center;
        margin-bottom: 1rem;
      }
    }
  }
`;

export const PAlert = styled.p`
  font-size: 11px;
  text-align: center;
  color: ${props => props.theme.colors.muted};
`;